<template>
  <div class="static-qrcode">
    <div class="qrcode-container">
      <div class="dimension">
        <span>{{qrcodeSize}} × {{qrcodeSize}}</span>
      </div>
      <QrcodeContainer ref="qrcodeCont"
                       class="qrcode-image"
                       :width="qrcodeSize"
                       :height="qrcodeSize"
                       :text="qrcodeText"></QrcodeContainer>
      <div class="button-group">
        <el-button size="mini" type="primary" round @click="handleQrcodePrint">打印</el-button>
        <el-button size="mini" type="warning" round @click="handleQrcodeDownload">下载</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeContainer from '../../../../../../../../../elements/QrcodeContainer'
export default {
  name: 'StaticQrcode',
  components: {
    QrcodeContainer
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    signInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      qrcodeSize: 136
    }
  },
  computed: {
    qrcodeText: function () {
      console.log('2', this.signInfo)
      // 使用Base64编码行数据ID
      if (this.signInfo && this.signInfo.qrcodeUrl && this.signInfo.id) {
        return `${this.signInfo.qrcodeUrl}${this.signInfo.id}`
      }
      // 如果signInfo不存在或不完整，显示错误
      this.$message.error('二维码信息不完整，无法生成二维码')
      return ''
    },
    displayName: function () {
      // 获取显示名称
      if (this.rowData.course) {
        return this.rowData.course
      }
      return this.rowData.name || ''
    }
  },
  methods: {
    handleQrcodePrint () {
      let qrcodeCont = this.$refs.qrcodeCont
      if (qrcodeCont) {
        // 打印二维码
        const title = `二维码(${this.displayName})`
        this.printQrcode(title, qrcodeCont.$el.innerHTML, this.qrcodeSize)
      }
    },
    handleQrcodeDownload () {
      let qrcodeCont = this.$refs.qrcodeCont
      if (qrcodeCont) {
        let img = qrcodeCont.$el.getElementsByTagName('img')[0]
        if (img) {
          // 下载二维码
          const fileName = `二维码(${this.displayName})`
          this.downloadQrcode(fileName, img, this.qrcodeSize)
        }
      }
    },
    printQrcode (title, content, size) {
      const printWindow = window.open('', '_blank')
      if (printWindow) {
        printWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>${title}</title>
            <style>
              body { margin: 0; padding: 20px; text-align: center; }
              .qrcode { width: ${size}px; height: ${size}px; margin: 0 auto; }
              h2 { margin-bottom: 20px; }
            </style>
          </head>
          <body>
            <h2>${title}</h2>
            <div class="qrcode">${content}</div>
          </body>
          </html>
        `)
        printWindow.document.close()
        setTimeout(() => {
          printWindow.print()
        }, 300)
      } else {
        this.$message.error('无法打开打印窗口，请检查浏览器设置')
      }
    },
    downloadQrcode (fileName, img, size) {
      try {
        // 创建canvas
        const canvas = document.createElement('canvas')
        canvas.width = size
        canvas.height = size
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = '#FFFFFF'
        ctx.fillRect(0, 0, size, size)
        ctx.drawImage(img, 0, 0, size, size)
        // 创建下载链接
        const link = document.createElement('a')
        link.download = `${fileName}.png`
        link.href = canvas.toDataURL('image/png')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (e) {
        this.$message.error('下载失败: ' + e.message)
      }
    }
  }
}
</script>

<style lang="scss">
  .static-qrcode {
    .qrcode-container {
      & > .dimension {
        font-size: 12px;
        color: #606266;
        text-align: center;
        margin-bottom: 6px;
      }
      & > .qrcode-image {
        margin: auto;
        display: block;
        width: 136px;
        height: 136px;
        background-color: #fafafa;
        padding: 4px;
        border: 1px solid #ebeef5;
        box-sizing: border-box;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      & > .button-group {
        margin-top: 10px;
        text-align: center;
        .el-button {
          padding: 4px 10px;
          & + .el-button {
            margin-left: 6px;
          }
        }
      }
    }
  }
</style>
